import { Injectable } from '@angular/core';
import { ServiceBase } from './ServiceBase';
import { HttpClient } from '@angular/common/http';
import { LoginResp } from 'src/model/User/LoginResp';
import { Observable } from 'rxjs';
import { LoginReq } from 'src/model/User/LoginReq';

@Injectable({
  providedIn: 'root'
})
export class UserService extends ServiceBase {
  protected baseUrl = `${this.apiBaseUrl}`;
  constructor(http: HttpClient) {
    super(http);
  }

  loign(request: LoginReq): Observable<LoginResp> {
    const url = `${this.baseUrl}/token`;
    let form = new FormData();
    form.append('username',request.username);
    form.append('password',request.password);
    return this.http.post<LoginResp>(url,form);
  }

}
